module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8004.55ad87dd.png";